import { Game } from './game';

async function asyncMain() {
    await (new Game("game-viewport")).setup()
}
asyncMain();
